module.exports = __webpack_public_path__ + "img/like.0c60ca2.gif";